import './index.scss'

import AppRoutes from './routes/index.tsx';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { StrictMode } from 'react'
import { ToastContainer } from 'react-toastify';
import { createRoot } from 'react-dom/client'

// import AppRoutes from './routes';
import { store } from './store';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig.ts';
import { MsalProvider } from '@azure/msal-react';
import 'react-toastify/dist/ReactToastify.css'

const msalInstance = new PublicClientApplication(msalConfig);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
                    <AppRoutes />
                    <ToastContainer position='top-center' />
        </MsalProvider>
    
      </BrowserRouter>
    </Provider>
  </StrictMode>,
)
